$(document).ready(function() {
    $(window).on('pageshow', function(event) {
        let navEntries = performance.getEntriesByType('navigation');
        let navType = '';
        if(navEntries.length > 0) {
            navType = navEntries[0].type;
        }
        if(event.originalEvent.persisted || navType === 'back_forward') {
            console.log('reloaded from server');
            window.location.reload();
        }
    });
});
